// 饼图的颜色值列表
export const pieColorsDefault = [
  '#1838D9',
  '#F53F3F',
  '#F77234',
  '#FFC542',
  '#FF7D00',
  '#F7BA1E',
  '#FADC19',
  '#9FDB1D',
  '#00B42A',
  '#14C9C9',
  '#3491FA',
  '#722ED1',
  '#D91AD9',
  '#F5319D',

  '#3CC68B',
  '#FFD03F',
  '#0D47A1',
  '#C32E2E',
  '#6FD7A8',
  '#FFC000',
];
